import React from 'react';
import './TransitionWrapper.scss';

const TransitionWrapper = ({ children, className = '' }) => {
  return <div className={`transition-wrapper ${className} `}>{children}</div>;
};

export default TransitionWrapper;
